module.exports = __webpack_public_path__ + "static/media/astronaut.44262ce0.png";